import { Box, ModBox, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../../../../../components/AdminButton'
import React, { useCallback, useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import { FlatListHeader } from './ListHeader'
import { RenderFlatListData } from './RenderItem'
import { styles } from './styles'

interface SelectParentEntityList {
  hide?: boolean
  title: string
  setFieldValue?: (fieldName: string, value: any) => void
  fieldName?: string
  data: any[]
  columnFlexMapper: any[]
  headerTitles: any[]
  showAddButton?: boolean
  onAddPress?: (event: any) => void
  onItemPress?: (data: any) => void
  type?: 'EMI' | 'default'
  extraData?: any
  onTextInputChange?: (id: string, gstNumber: string) => void
  onDelete?: (item: any) => void
  updateDefaultSelection?: (id: string, isChecked: string) => void
  onCheckboxPress?: (item: any, isChecked: boolean) => void
  onViewPress?: (data: any) => void
  onDownloadPress?: (data: any) => void
  isEditMode?: boolean
  nativeID?: string
  minHeight?: number
  onEditPress?: (data: any) => void
  onUndoPress?: (data: any) => void
  onReplace?: (item: any) => void
  hideColumnNames?: string[]
}

const SelectParentEntityList = React.memo(
  ({
    hide,
    title,
    data,
    columnFlexMapper,
    headerTitles,
    showAddButton = false,
    onAddPress,
    onItemPress,
    type = 'default',
    extraData = undefined,
    onTextInputChange,
    onDelete,
    updateDefaultSelection,
    onCheckboxPress,
    onViewPress,
    onDownloadPress,
    isEditMode,
    nativeID = '',
    minHeight,
    onEditPress,
    onUndoPress,
    onReplace,
    hideColumnNames,
    rowDataMapperKeys,
  }: SelectParentEntityList) => {
    const [selectedParentData, toggleSelectedParentData] = useState(null)
    const [stateData, updateStateData] = useState(data)

    React.useMemo(() => {
      // Adding radio button to each element
      if (type === 'default' && data && Array.isArray(data)) {
        data?.forEach((object) => {
          if (object && object.hasOwnProperty('isSelected')) {
            object.isSelected = false
          }
        })
      }
    }, [data, type])

    const onRowPress = useCallback(
      (data) => {
        toggleSelectedParentData(data?.parentId ?? data?.groupId) //TODO:groupId
        onItemPress && onItemPress(data)
      },
      [onItemPress],
    )

    const getFlatListHeader = () => {
      return <FlatListHeader headerTitles={headerTitles} columnFlexMapper={columnFlexMapper} type={type} />
    }

    useEffect(() => {
      updateStateData(data)
    }, [data])

    if (hide) {
      return null
    }
    console.log('stateData', stateData)
    const childTextAlignment = type === 'EMI' ? 'left' : undefined
    return (
      <Box width={'100%'} overflow={'auto'}>
        <Box direction="row" justifyContent={'space-between'} alignItems={'center'}>
          <TextNew title={title} {...styles.titleText} />
          <ModBox show={showAddButton} pv={8} height={40} justifyContent={'flex-end'} width={150}>
            <ButtonNew
              type={'secondaryIconSmall'}
              borderWidth={1}
              title={'Add Child'}
              borderColor={'#0070B6'}
              borderRadius={4}
              icon="ADD"
              onPress={onAddPress}
            />
          </ModBox>
        </Box>
        <ModBox
          overflow={'auto'}
          h={minHeight && minHeight > 0 ? minHeight : undefined}
          minWidth={headerTitles?.length * 200}>
          <FlatList
            nativeID={nativeID}
            data={stateData}
            ListHeaderComponent={stateData?.length > 0 ? getFlatListHeader() : null}
            ListEmptyComponent={() => (
              <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />
            )}
            renderItem={({ item, index }) => (
              <RenderFlatListData
                item={item}
                index={index}
                onRowPress={onRowPress}
                selectedParentData={selectedParentData}
                columnFlexMapper={columnFlexMapper}
                dataLength={stateData.length}
                childTextAlignment={childTextAlignment}
                onTextInputChange={onTextInputChange}
                onDelete={onDelete}
                updateDefaultSelection={updateDefaultSelection}
                onCheckboxPress={onCheckboxPress}
                onViewPress={onViewPress}
                onDownloadPress={onDownloadPress}
                isEditMode={isEditMode}
                onEditPress={onEditPress}
                onUndoPress={onUndoPress}
                onReplace={onReplace}
                hideColumnNames={hideColumnNames}
                rowDataMapperKeys={rowDataMapperKeys}
              />
            )}
            extraData={extraData ?? stateData}
            // keyExtractor={(item, index) => item?.id}
          />
        </ModBox>
      </Box>
    )
  },
)

export { SelectParentEntityList }
